import { JsonProperty } from "../../../models/utilities/json-property";
import { EventStatus } from "../enums/event-status";
import { EventType } from "../enums/event-type";

export class SearchEventSummary {
    
    public id : number = 0;

    public eventId : string = '';
    
    public status : EventStatus = EventStatus.Pending;

    public type : EventType = EventType.Command;

    public typeName : string = '';

    public correlationId : string = '';

    public causationId : string = '';

    public userId : string = '';

    public entity : string = '';

    @JsonProperty({ toType: 'datetime' })
    public createdOn : Date = new Date();

}
